import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=72acb0f4&scoped=true"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=72acb0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72acb0f4",
  null
  
)

export default component.exports